import utils from '@/plugins/TravellerUtils';

const infopoint = {
    namespaced: true,
    state: {
        infopointList: [],
        infopointListTimestamp: null,
        infopointTypeList: [],
        mediaGroupList: [],
        layouts: [],
        IMSlayouts: [],
        channels: [],
        mechannels: [],
        IMSContent: {},
        selectedInfopoint: null,
        screenshots: {},
        timetableViews: {},
        infopointLabel: '',
        infopointConfiguration: {}
    },
    mutations: {
        updateInfopointList(state, newList) {
            state.infopointListTimestamp = new Date().getTime();
            state.infopointList = newList;
            
            // Alustetaan kuvankaappausten src-attribuutit, muuten tulee undefined-virheitä.
            /*
            for (const i in newList) {
                state.screenshots[newList[i].uniqueId] = 'null';
            }
            */
        },
        setInfopointLabel (state, infopointLabel) {
            state.infopointLabel = infopointLabel;
        },
        setInfopointConfiguration (state, configuration) {
            state.infopointConfiguration = configuration;
        },
        updateInfopointVolume (state, volume) {
            state.infopointConfiguration.configurations = [{ key: "VOLUME", value: volume }];
        },
        updateInfopointTypeList(state, newList) {
            state.infopointTypeList = newList;
        },
        updateMediaGroupList(state, newList) {
            state.mediaGroupList = newList;
        },
        updateLayouts(state, newList) {
            state.layouts = newList;
        },
        updateIMSLayouts(state, newList) {
            state.IMSlayouts = newList;
        },
        updateChannels(state, newList) {
            state.channels = newList;
        },
        updateMEChannels(state, newList) {
            state.mechannels = newList;
        },
        updateIMSContent(state, content) {
            state.IMSContent = content;
        },
        changeSelectedInfopoint(state, infopoint) {
            state.selectedInfopoint = infopoint;

           // console.log("changeSelectedInfopoint: " + infopoint)
           
        },
        putTimetableViews(state, views) {
            for (const i in views) {
                if (views.hasOwnProperty(i)) {
                    state.timetableViews[i] = views[i];
                }
            }
            state.timetableViews = { ...state.timetableViews };
        },
        putScreenshot(state, image) {
            //state.screenshots[image.identifier] = image.base64;
            state.screenshots[image.identifier] = image;
         
            // screenshots-olion yksittäisen jäsenen muuttaminen ei saa aikaan computed propertyjen päivitystä.
            state.screenshots = { ...state.screenshots };
        }
    },
    actions: {
        getInfopointList(context, expireTime = 3600) {
            return new Promise((resolve, reject) => {
              const cacheKey = 'infopoint_list_cache';
              const expiryKey = 'infopoint_list_cache_expiry';
              const now = Date.now();
          
              const cacheDuration = (typeof expireTime === 'number' && expireTime > 0)
                ? expireTime * 1000
                : 3600 * 1000; // 1h

              const cached = localStorage.getItem(cacheKey);
              const expiry = localStorage.getItem(expiryKey);
          
              if (cached && expiry && now < parseInt(expiry)) {
                try {
                  const parsed = JSON.parse(cached);
                  context.commit('updateInfopointList', parsed);
                } catch (e) {
                  console.warn('Failed to parse cached infopoint list:', e);
                }
              }
          
              this._vm.$traveller_http.get('/traveller/restui/infopoint/list')
                .then(response => {
                  if (utils.checkResponseIsArray(response)) {
                    localStorage.setItem(cacheKey, JSON.stringify(response.data));
                    localStorage.setItem(expiryKey, (now + cacheDuration).toString());
          
                    context.commit('updateInfopointList', response.data);
                    resolve(response.data);
                  } else {
                    reject('could not get infopoint list, invalid response format');
                  }
                }, error => {
                  console.error('infopoint list fetch failed', error);
                  reject(error);
                });
            });
          },
        getInfopointTypeList(context) {
            this._vm.$traveller_http.get('/traveller/restui/infopoint/getInfopointTypes')
                .then(response => {
                    context.commit('updateInfopointTypeList', response.data);
                });
        },
        getMediaGroupList(context) {
            this._vm.$traveller_http.get('/traveller/restui/infopoint/getMediaGroups')
                .then(function(response) {
                    context.commit('updateMediaGroupList', response.data);
                });
        },
        getTimetableViews(context, idList) {
            return new Promise((resolve, reject) => {
                this._vm.$traveller_http.post('/traveller/restui/infopoint/getTimetableViews', idList)
                    .then(response => {
                        if (response.status == 200) {
                            context.commit('putTimetableViews', response.data);
                        }
                        resolve(response);
                    }),
                error => {
                    reject(error);
                }
            });
        },
        getScreenshot(context, identifier) {
            return new Promise((resolve, reject) => {
                this._vm.$traveller_http.get('/traveller/restui/infopoint/getScreenshot', { params: { "identifier": identifier } })
                    .then(response => {
                        if (response.status == 200) {
                            context.commit('putScreenshot', {
                                identifier: identifier,
                                base64: response.data.base64,
                                timestamp: response.data.timestamp
                            });
                        }
                        resolve(response);
                    }),
                error => {
                    reject(error);
                }
            });
        },
        saveInfopoint(context, newInfopoint) {
            newInfopoint.device.attributes = JSON.parse(JSON.stringify(newInfopoint.device.configuration));
            delete newInfopoint.device.configuration;
            
            return new Promise((resolve, reject) => {
                this._vm.$traveller_http.post('/traveller/restui/infopoint/saveInfopoint', newInfopoint)
                    .then(response => {
                        if (response.status == 200) {
                            context.dispatch('getInfopointList');
                        }
                        resolve(response);
                        //context.commit('changeSelectedInfopoint', null);
                        //console.log("saveInfopoint ready")
                    }),
                error => {
                    reject(error);
                }
            });
        },
        deleteInfopoint(context, infopointId) {
            return new Promise((resolve, reject) => {
                this._vm.$traveller_http.get('/traveller/restui/infopoint/deleteInfopoint', { params: { "id": infopointId } })
                    .then(response => {
                        if (response.status == 200) {
                            context.dispatch('getInfopointList');
                        }
                        resolve(response);
                        context.commit('changeSelectedInfopoint', null);
                    }),
                error => {
                    reject(error);
                }
            });
        },
        deleteChannel(context, data) {
            return new Promise((resolve, reject) => {
                this._vm.$traveller_http.get('/traveller/restui/infopoint/deleteChannel', { params: data})
                    .then(response => {
                        if (response.status == 200) {
                            context.dispatch('getInfopointList');
                        }
                        resolve(response);
                    }),
                error => {
                    reject(error);
                }
            });
        },
        addChannel(context, data) {
            return new Promise((resolve, reject) => {
                this._vm.$traveller_http.get('/traveller/restui/infopoint/addChannel', { params: data})
                    .then(response => {
                        if (response.status == 200) {
                            context.dispatch('getInfopointList');
                        }
                        resolve(response);
                    }),
                error => {
                    reject(error);
                }
            });
        },
        moveChannel(context, data) {
            return new Promise((resolve, reject) => {
                this._vm.$traveller_http.get('/traveller/restui/infopoint/moveChannelUp', { params: data})
                    .then(response => {
                        if (response.status == 200) {
                            context.dispatch('getInfopointList');
                        }
                        resolve(response);
                    }),
                error => {
                    reject(error);
                }
            });
        },
        updateChannel(context, data) {
            return new Promise((resolve, reject) => {
                this._vm.$traveller_http.get('/traveller/restui/infopoint/updateChannel', { params: data})
                    .then(response => {
                        if (response.status == 200) {
                            context.dispatch('getInfopointList');
                        }
                        resolve(response);
                    }),
                error => {
                    reject(error);
                }
            });
        },
        updateMEChannel(context, data) {
            return new Promise((resolve, reject) => {
                this._vm.$traveller_http.get('/traveller/restui/infopoint/updateMEChannel', { params: data})
                    .then(response => {
                        if (response.status == 200) {
                            context.dispatch('getInfopointList');
                        }
                        resolve(response);
                    }),
                error => {
                    reject(error);
                }
            });
        },
        sendLayouts(context, id) {
            context.dispatch('sendAction', 'sendLayouts', id);
        },
        sendDepartures(context, id) {
            context.dispatch('sendAction', 'sendDepartures', id);
        },
        sendAnnouncements(context, id) {
            context.dispatch('sendAction', 'sendAnnouncements', id);
        },
        sendCaptureRequest(context, id) {
            context.dispatch('sendAction', 'sendCaptureRequests', id);
        },
        sendAction(context, action, id) {
            var idList = [];
            if (id) {
                if (id.length) {
                    idList = id;
                } else {
                    idList.push(id);
                }
            }
            return new Promise((resolve, reject) => {
                this._vm.$traveller_http.post('/traveller/restui/infopoint/'+ action, idList)
                    .then(response => { resolve(response); }),
                    error => { reject(error); }
            });
        },
        sendRebootRequest(context, infopointId) {
            return new Promise((resolve, reject) => {
                this._vm.$traveller_http.get('/traveller/restui/infopoint/sendRebootRequest', { params: { "id": infopointId } })
                    .then(response => { resolve(response); }),
                error => { reject(error); }
            });
        },
        getLayouts(context) {
            this._vm.$traveller_http.get('/traveller/restui/infopoint/getLayouts')
                .then(function(response) {
                    context.commit('updateLayouts', response.data);
                });
        },
        getIMSLayouts(context) {
            this._vm.$traveller_http.get('/traveller/restui/infopoint/getIMSLayouts')
                .then(function(response) {
                    context.commit('updateIMSLayouts', response.data);
                });
        },
        getIMSContent(context, infopointId) {
            this._vm.$traveller_http.get('/traveller/restui/infopoint/getIMSContent', { params: { "id": infopointId } })
                .then(function(response) {
                    context.commit('updateIMSContent', response.data);
                });
        },
        getChannels(context) {
            this._vm.$traveller_http.get('/traveller/restui/infopoint/getChannels')
                .then(function(response) {
                    context.commit('updateChannels', response.data);
                });
        },
        loadConfiguration ({ commit }, infopointLabel) {
            return this._vm.$traveller_http.get('/traveller/restui/infopoint/getConfiguration', {
                    params: { infopointLabel }
                }).then(function(response) {
                    commit('setInfopointLabel', infopointLabel);
                    commit('setInfopointConfiguration', response.data);
                    return response;
                });
        },
        saveConfiguration({ state }) {
            try {
                const payload = {
                    infopointLabel: state.infopointLabel,
                    configurations: state.infopointConfiguration.configurations
                };
               this._vm.$traveller_http.post('/traveller/restui/infopoint/setConfiguration', payload);
            } catch (error) {
                console.error("Error saving config", error);
            }
        },
        updateVolume ({ commit, dispatch }, payload) {
            if (!payload?.volume) return;
            commit('setInfopointLabel', payload.infopointLabel);
            commit('updateInfopointVolume', payload.volume);
            dispatch('saveConfiguration');
        },
        getMEChannels(context) {
            this._vm.$traveller_http.get('/traveller/restui/infopoint/getMEChannels')
                .then(function(response) {
                    context.commit('updateMEChannels', response.data);
                });
        },
        saveInfopointContent(context, infopointContent) {            
            return new Promise((resolve , reject) => {
                this._vm.$traveller_http.post('/traveller/restui/infopoint/saveContent', infopointContent )
                .then ( response => {
                  
                    if( response.status == 200 ) context.dispatch('getInfopointList');

                    resolve(response);
                    
                }), error => {
                    reject(error);
                }
            } )
            
        },
        saveIMSLayout(context, infopointContent) {
            return new Promise((resolve , reject) => {
                this._vm.$traveller_http.post('/traveller/restui/infopoint/saveIMSLayout', infopointContent )
                .then ( response => {
                  
                    if( response.status == 200 ) context.dispatch('getInfopointList');

                    resolve(response);
                    
                }), error => {
                    reject(error);
                }
            } )
            
        }
    },
    getters: {
        infopointList: (state) => {
            return state.infopointList || [];
        },
        getInfopointById: (state) => (id) => {
            return state.infopointList.find(infopoint => infopoint.id === id);
        },
        deviceVolume: (state) => {
            try {
                var value = state.infopointConfiguration[0].value
                if (value) {
                    return value;
                }
            } catch (err) {
                console.warn('Volume configuration value not found')
                return '';
            }
        }
    }
}

export default infopoint;
